// pages/VentaDirectaForm.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Row,
  Col,
  Card,
  InputNumber,
  Divider,
  DatePicker,
  Table,
  Modal,
  Switch,
  Tabs,
  Tooltip,
  Popconfirm,
  Badge,
  Statistic,
  Spin,
  List,
  Avatar
} from 'antd';
import {
  SaveOutlined,
  RollbackOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  UserOutlined,BankOutlined  ,
  HomeOutlined,
  CalendarOutlined,TeamOutlined,
  EuroOutlined,
  FileTextOutlined,
  BarcodeOutlined,
  DollarOutlined,
  NumberOutlined,
  EnvironmentOutlined,
  IdcardOutlined,
  GlobalOutlined,
  TagOutlined,
  FileAddOutlined,
  AppstoreOutlined,
  ShoppingOutlined,
  CloseOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { Search } = Input;

const VentaDirectaForm = () => {

  const renderFlag = (codigoISO) => {
    if (!codigoISO || codigoISO.trim() === '') {
      return <span style={{ marginRight: '8px' }}>🌍</span>;
    }
    return <span className={`fi fi-${codigoISO.toLowerCase()}`} style={{ marginRight: '8px' }} />;
  };
  const [paises, setPaises] = useState([]);  




  // Estados
  const [esParticular, setEsParticular] = useState(false);  
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
  const [lineaForm] = Form.useForm();
  
  // Datos de líneas
  const [lineas, setLineas] = useState([]);
  const [editingLineaIndex, setEditingLineaIndex] = useState(null);
  const [lineaModalVisible, setLineaModalVisible] = useState(false);
  
  // Datos de catálogos
  const [secciones, setSecciones] = useState([]);
  const [tiposIVA, setTiposIVA] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [cargosFiltered, setCargosFiltered] = useState([]);
  const [agencias, setAgencias] = useState([]);

  
  // Modal de búsqueda de cargos
  const [cargosModalVisible, setCargosModalVisible] = useState(false);
  const [cargosLoading, setCargosLoading] = useState(false);
  const [cargosSearchText, setCargosSearchText] = useState('');

  const [agenciasModalVisible, setAgenciasModalVisible] = useState(false);
  const [agenciasLoading, setAgenciasLoading] = useState(false);
  const [agenciasList, setAgenciasList] = useState([]);
  const [agenciasFiltered, setAgenciasFiltered] = useState([]);
  const [agenciasSearchText, setAgenciasSearchText] = useState('');  

 const [buscarParticularModalVisible, setBuscarParticularModalVisible] = useState(false);
 const [buscarParticularLoading, setBuscarParticularLoading] = useState(false);
 const [buscarParticularList, setBuscarParticularList] = useState([]);
 const [buscarParticularFiltered, setBuscarParticularFiltered] = useState([]);
 const [buscarParticularSearchText, setBuscarParticularSearchText] = useState('');  
  
  // Buscador de agencia
  const [buscarAgenciaLoading, setBuscarAgenciaLoading] = useState(false);
  
  // Cargar datos iniciales
  useEffect(() => {
    cargarCatalogos();
    cargarCargos();
    
    // Establecer valores por defecto
    form.setFieldsValue({
      Fecha: dayjs(),
      INCDEC: 'I',
      Moneda: 'EUR',
      CambioMoneda: 1,
      FacturarEmpresa: false,
      CheckRetencion: false,
      Serie: 'A',
      Ejercicio: new Date().getFullYear().toString(),
      BaseImponible: 0,
      ImporteIVA: 0,
      Total: 0
    });
  }, []);

  const cargarParticulares = async (search = '') => {
    setBuscarParticularLoading(true);
    try {
        const token = localStorage.getItem('token');
        const facturarEmpresa = form.getFieldValue('FacturarEmpresa');
        const endpoint = facturarEmpresa ? 'empresas' : 'particulares';
        
        const response = await axios.get(`${BASE_URL}/api/${endpoint}`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { search }
        });
        
        setBuscarParticularList(response.data.data || []);
        setBuscarParticularFiltered(response.data.data || []);
        
    } catch (error) {
        console.error('Error cargando datos:', error);
        message.error('Error al cargar los datos');
    } finally {
        setBuscarParticularLoading(false);
    }
  };

  const handleOpenParticularModal = () => {
    setBuscarParticularModalVisible(true);
    setBuscarParticularSearchText('');
    cargarParticulares();
  };

  const handleSearchParticular = (value) => {
    setBuscarParticularSearchText(value);
    if (value) {
        const filtered = buscarParticularList.filter(item => 
            item.Codigo?.toLowerCase().includes(value.toLowerCase()) ||
            item.Nombre?.toLowerCase().includes(value.toLowerCase()) ||
            item.Nif?.toLowerCase().includes(value.toLowerCase())
        );
        setBuscarParticularFiltered(filtered);
    } else {
        setBuscarParticularFiltered(buscarParticularList);
    }
  };

  const handleSelectParticular = (item) => {
    const esEmpresa = item.tipo === 'empresa';
    const codigo = item.Codigo;
    const codigoUpper = codigo?.toUpperCase() || '';
    const esParticularCliente = codigoUpper === 'PARTICULARES' || codigoUpper === 'PARTICULARS' || !esEmpresa;
    
    setEsParticular(true); // Siempre es particular o empresa
    
    form.setFieldsValue({
        //Agencia: codigo,
        NomAgencia: item.Nombre || '',
        DirAgencia: item.Direccion || '',
        PobAgencia: item.Poblacion || '',
        CPAgencia: item.CodPostal || '',
        NifAgencia: item.Nif || '',
        ProvAgencia: item.Provincia || '',
        PaisAgencia: item.Pais || ''
    });
    
    setBuscarParticularModalVisible(false);
    message.success(`${esEmpresa ? 'Empresa' : 'Particular'} seleccionado: ${codigo} - ${item.Nombre}`);
  };

  // Cargar catálogos
  const cargarCatalogos = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Cargar secciones
      const seccionesRes = await axios.get(`${BASE_URL}/api/secciones`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSecciones(seccionesRes.data.data || []);
      
      // Cargar tipos de IVA
      const ivaRes = await axios.get(`${BASE_URL}/api/tiposiva`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTiposIVA(ivaRes.data.data || []);


      const responsePaises = await axios.get(`${BASE_URL}/api/paises`, {
        headers: { Authorization: `Bearer ${token}` }
      });      

      setPaises(responsePaises.data.data)      
      
    } catch (error) {
      console.error('Error cargando catálogos:', error);
      message.error('Error al cargar los catálogos');
    }
  };

  // Cargar las agencias
  const cargarAgencias = async (search = '') => {
    setAgenciasLoading(true);
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${BASE_URL}/api/agencias`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { search }
        });
        
        setAgenciasList(response.data.data || []);
        setAgenciasFiltered(response.data.data || []);
        
    } catch (error) {
        console.error('Error cargando agencias:', error);
        message.error('Error al cargar las agencias');
    } finally {
        setAgenciasLoading(false);
    }
  };

  // Cargar todos los cargos
  const cargarCargos = async (search = '') => {
    setCargosLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/cargos`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { search }
      });
      
      
      
      setCargos(response.data.data || []);
      setCargosFiltered(response.data.data || []);
      
    } catch (error) {
      console.error('Error cargando cargos:', error);
      message.error('Error al cargar los cargos');
    } finally {
      setCargosLoading(false);
    }
  };


  // Verificar el tipo de agencia
  const verificarTipoAgencia = (codigo) => {
    const codigoUpper = codigo?.toUpperCase() || '';
    const esParticularTipo = codigoUpper === 'PARTI' || codigoUpper === 'PARTICULARS';
    setEsParticular(esParticularTipo);
    return esParticularTipo;
  };  
  // Buscar cargos por texto
  const handleSearchCargos = (value) => {
    setCargosSearchText(value);
    if (value) {
      const filtered = cargos.filter(cargo => 
        cargo.codigo?.toLowerCase().includes(value.toLowerCase()) ||
        cargo.descripcion?.toLowerCase().includes(value.toLowerCase())
      );
      setCargosFiltered(filtered);
    } else {
      setCargosFiltered(cargos);
    }
  };


  const handleOpenAgenciasModal = () => {
    setAgenciasModalVisible(true);
    setAgenciasSearchText('');
    cargarAgencias();
  };

  const handleSearchAgencias = (value) => {
    setAgenciasSearchText(value);
    if (value) {
        const filtered = agenciasList.filter(cliente => 
            cliente.Codigo?.toLowerCase().includes(value.toLowerCase()) ||
            cliente.Nombre?.toLowerCase().includes(value.toLowerCase()) ||
            cliente.NIF?.toLowerCase().includes(value.toLowerCase())
        );
        setAgenciasFiltered(filtered);
    } else {
        setAgenciasFiltered(agenciasList);
    }
  };

  
  const handleSelectAgencia = (cliente) => {
    const esParticularTipo = cliente.tipo === 'particular';
    const codigo = cliente.Codigo;
    const codigoUpper = codigo?.toUpperCase() || '';

    const nombre = cliente.Nombre;
    const nombreUpper = nombre?.toUpperCase() || '';
    const esParticularCliente = nombreUpper === 'PARTICULARES' || nombreUpper === 'PARTICULARS' || esParticularTipo;
    
    setEsParticular(esParticularCliente);
    
    form.setFieldsValue({
        Agencia: codigo,
        NomAgencia: cliente.Nombre || '',
        DirAgencia: cliente.Direccion || '',
        PobAgencia: cliente.Poblacion || '',
        CPAgencia: cliente.CodPostal || '',
        NifAgencia: cliente.NIF || '',
        ProvAgencia: cliente.Provincia || '',
        PaisAgencia: cliente.Pais || ''
    });
    
    setAgenciasModalVisible(false);
    message.success(`${esParticularCliente ? 'Particular' : 'Agencia'} seleccionado: ${codigo} - ${cliente.Nombre}`);
  };

  // Abrir modal de cargos
  const handleOpenCargosModal = () => {
    setCargosModalVisible(true);
    setCargosSearchText('');
    cargarCargos();
  };

  // Seleccionar un cargo
  const handleSelectCargo = (cargo) => {
    // Verificar que la sección existe
    
    
    if (cargo.seccion) {
      const seccionExiste = secciones.some(sec => sec.Codigo === cargo.seccion);
      if (!seccionExiste) {
        message.warning(`El cargo tiene una sección (${cargo.seccion}) que no existe en el sistema`);
      }
    }

    lineaForm.setFieldsValue({
      CodigoCargo: cargo.codigo,
      Descripcion: cargo.descripcion || '',
      Seccion: cargo.seccion || '',
      Precio: cargo.precio || 0,
      CodigoIVA: cargo.codigoiva || ''
    });
    
    setCargosModalVisible(false);
    message.success(`Cargo seleccionado: ${cargo.codigo} - ${cargo.descripcion}`);
  };

  // --- Funciones de búsqueda de agencia ---

  const handleBuscarAgencia = async () => {
   
    setBuscarAgenciaLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/agencias/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const data = response.data.data;
      const esParticular = data.tipo === 'particular';
      
      form.setFieldsValue({
        NomAgencia: data.Nombre || '',
        DirAgencia: data.Direccion || '',
        PobAgencia: data.Poblacion || '',
        CPAgencia: data.CodPostal || '',
        NifAgencia: data.NIF || '',
        ProvAgencia: data.Provincia || '',
        PaisAgencia: data.Pais || ''
      });
      
      if (esParticular) {
        message.success(`Particular encontrado: ${data.Nombre}`);
      } else {
        message.success(`Agencia encontrada: ${data.Nombre}`);
      }
      
    } catch (error) {
      message.error(error.response?.data?.error || 'Error al buscar la agencia');
    } finally {
      setBuscarAgenciaLoading(false);
    }
  };

  // --- Gestión de líneas ---

  const handleAddLinea = () => {
    setEditingLineaIndex(null);
    lineaForm.resetFields();
    lineaForm.setFieldsValue({
      DiasCant: 1,
      IncDec: form.getFieldValue('INCDEC') || 'I',
      Precio: 0,
      Hab: 0,
      NReserva: 0
    });
    setLineaModalVisible(true);
  };

  const handleEditLinea = (index) => {
    setEditingLineaIndex(index);
    const linea = lineas[index];
    lineaForm.setFieldsValue({
      ...linea,
      FechaEnt: linea.FechaEnt ? dayjs(linea.FechaEnt) : null,
      FechaSal: linea.FechaSal ? dayjs(linea.FechaSal) : null
    });
    setLineaModalVisible(true);
  };

  const handleDeleteLinea = (index) => {
    const newLineas = lineas.filter((_, i) => i !== index);
    setLineas(newLineas);
    recalcularTotales(newLineas);
    message.success('Línea eliminada');
  };

  const handleSaveLinea = async () => {
    try {
      const values = await lineaForm.validateFields();
      
      // Validar sección si existe
      if (values.Seccion) {
        const seccionExiste = secciones.some(sec => sec.Codigo === values.Seccion);
        if (!seccionExiste) {
          message.warning(`La sección ${values.Seccion} no existe en el sistema`);
        }
      }
      
      // Calcular fechas
      const fechaEnt = values.FechaEnt ? values.FechaEnt.toDate() : new Date();
      let fechaSal = values.FechaSal ? values.FechaSal.toDate() : new Date(fechaEnt);
      if (fechaSal <= fechaEnt) {
        fechaSal = new Date(fechaEnt);
        fechaSal.setDate(fechaSal.getDate() + 1);
      }
      
      const diffTime = Math.abs(fechaSal - fechaEnt);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const dias = diffDays > 0 ? diffDays : 1;
      
      // Buscar valor del IVA
    //   console.log(" tiposIVA => ",tiposIVA);
    //   console.log(" values => ",values.CodigoIVA);
      
      const tipoIVA = tiposIVA.find(t => String(t.Codigo) === String(values.CodigoIVA));
      const valorIVA = tipoIVA?.ValorActual || 0;

    //   console.log(" tipoIVA => ",tipoIVA);
      
      const totalLinea = dias * (values.DiasCant || 1) * (values.Precio || 0);

    //   console.log(" totalLinea => ",totalLinea);
      
      
      // Calcular importes según INCDEC
      let importeBaseLinea, importeIVALinea;
      const incDec = values.IncDec || 'I';
      
      if (incDec === 'I') {
        const baseSinIVA = totalLinea / (1 + (valorIVA / 100));
        importeIVALinea = totalLinea - baseSinIVA;
        importeBaseLinea = baseSinIVA;
        // console.log(baseSinIVA,importeIVALinea,importeBaseLinea);
        
      } else {
        importeBaseLinea = totalLinea;
        importeIVALinea = totalLinea * (valorIVA / 100);
      }
      
      const nuevaLinea = {
        ...values,
        FechaEnt: fechaEnt,
        FechaSal: fechaSal,
        Dias: dias,
        TotalLin: totalLinea,
        ImporteLinea: totalLinea,
        ImporteBase: importeBaseLinea,
        ImporteIVA: importeIVALinea,
        ValorIVA: valorIVA
      };
      
      let newLineas;
      if (editingLineaIndex !== null) {
        newLineas = [...lineas];
        newLineas[editingLineaIndex] = nuevaLinea;
        message.success('Línea actualizada');
      } else {
        newLineas = [...lineas, nuevaLinea];
        message.success('Línea añadida');
      }
      
      setLineas(newLineas);
      recalcularTotales(newLineas);
      setLineaModalVisible(false);
      lineaForm.resetFields();
      
    } catch (error) {
      console.error('Error guardando línea:', error);
      message.error('Error al guardar la línea');
    }
  };

  // Recalcular totales de la factura
  const recalcularTotales = (lineasData = lineas) => {
    let baseImponible = 0;
    let importeIVA = 0;
    let total = 0;

    // console.log(" lineasDAta => ",lineasData);
    
    
    lineasData.forEach(linea => {
      baseImponible += linea.ImporteBase || 0;
      importeIVA += linea.ImporteIVA || 0;
      total += linea.TotalLin || 0;
    });
    
    form.setFieldsValue({
      BaseImponible: parseFloat(baseImponible.toFixed(2)),
      ImporteIVA: parseFloat(importeIVA.toFixed(2)),
      Total: parseFloat(total.toFixed(2))
    });
  };

  // --- Guardar factura ---

  const handleSaveFactura = async () => {
    try {
      const values = await form.validateFields();
      
      // Validar que tenga líneas
      if (lineas.length === 0) {
        message.error('La factura debe tener al menos una línea');
        return;
      }
      
      setSaving(true);
      
      const token = localStorage.getItem('token');
      
      const facturaData = {
        ...values,
        Fecha: values.Fecha ? values.Fecha.format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
        lineas: lineas.map(linea => ({
          ...linea,
          FechaEnt: linea.FechaEnt ? dayjs(linea.FechaEnt).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
          FechaSal: linea.FechaSal ? dayjs(linea.FechaSal).format('YYYY-MM-DD') : dayjs().add(1, 'day').format('YYYY-MM-DD')
        })),
        Usuario: localStorage.getItem('usuario') || 'admin',
        CodigoHotel: parseInt(localStorage.getItem('codigoHotel')) || 1,
        Ejercicio: values.Ejercicio || new Date().getFullYear().toString()
      };
      
      const response = await axios.post(
        `${BASE_URL}/api/ventas-directas`,
        facturaData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      message.success(`Factura ${response.data.data.nFacturaCompleto} creada correctamente`);
      
      // Limpiar formulario
      setLineas([]);
      form.resetFields();
      form.setFieldsValue({
        Fecha: dayjs(),
        INCDEC: 'I',
        Moneda: 'EUR',
        CambioMoneda: 1,
        FacturarEmpresa: false,
        CheckRetencion: false,
        Serie: 'A',
        Ejercicio: new Date().getFullYear().toString(),
        BaseImponible: 0,
        ImporteIVA: 0,
        Total: 0
      });
      
    } catch (error) {
      console.error('❌ Error guardando factura:', error);
      message.error(error.response?.data?.error || 'Error al guardar la factura');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setLineas([]);
    form.resetFields();
    form.setFieldsValue({
      Fecha: dayjs(),
      INCDEC: 'I',
      Moneda: 'EUR',
      CambioMoneda: 1,
      FacturarEmpresa: false,
      CheckRetencion: false,
      Serie: 'A',
      Ejercicio: new Date().getFullYear().toString(),
      BaseImponible: 0,
      ImporteIVA: 0,
      Total: 0
    });
    message.info('Formulario limpiado');
  };

  // --- Columnas de líneas ---

  const lineasColumns = [
    {
      title: '#',
      dataIndex: 'i',
      key: 'i',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Código',
      dataIndex: 'CodigoCargo',
      key: 'CodigoCargo',
      width: 80,
      render: (value) => <Tag color="blue">{value || '-'}</Tag>
    },
    {
      title: 'Descripción',
      dataIndex: 'Descripcion',
      key: 'Descripcion',
      ellipsis: true,
      width: 180
    },
    {
      title: 'Cant',
      dataIndex: 'DiasCant',
      key: 'DiasCant',
      width: 60,
      align: 'right'
    },
    {
      title: 'Precio',
      dataIndex: 'Precio',
      key: 'Precio',
      width: 90,
      align: 'right',
      render: (value) => `€ ${value?.toFixed(2) || '0.00'}`
    },
    {
      title: 'Total',
      dataIndex: 'TotalLin',
      key: 'TotalLin',
      width: 100,
      align: 'right',
      render: (value) => `€ ${value?.toFixed(2) || '0.00'}`
    },
    {
      title: 'Sección',
      dataIndex: 'Seccion',
      key: 'Seccion',
      width: 80,
      render: (value) => value ? <Tag color="blue">{value}</Tag> : '-'
    },
    {
      title: 'Fechas',
      key: 'fechas',
      width: 130,
      render: (_, record) => (
        <div style={{ fontSize: '12px' }}>
          <div>Ent: {record.FechaEnt ? dayjs(record.FechaEnt).format('DD/MM') : '-'}</div>
          <div>Sal: {record.FechaSal ? dayjs(record.FechaSal).format('DD/MM') : '-'}</div>
        </div>
      )
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 100,
      render: (_, __, index) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              type="link"
              icon={<EditOutlined />}
              size="small"
              onClick={() => handleEditLinea(index)}
            />
          </Tooltip>
          <Tooltip title="Eliminar">
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => handleDeleteLinea(index)}
            />
          </Tooltip>
        </Space>
      )
    }
  ];

  return (
    <>
      <PageContainer
        title="Nueva Venta Directa"
        subtitle="Complete los datos para generar la factura"
        icon={<FileAddOutlined />}
        loading={loading}
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}
      >
        <Spin spinning={saving} tip="Guardando factura...">
          <Form
            form={form}
            layout="vertical"
          >
            {/* Sección 1: Datos del Cliente */}
            <Card 
              title={
                <Space>
                  <UserOutlined />
                  <span>Datos del Cliente</span>
                </Space>
              }
              style={{ marginBottom: 16 }}
            >
              <Row gutter={16}>                              
                <Col span={6}>
                    <Form.Item
                        name="Agencia"
                        label="Código"
                        rules={[{ required: true, message: 'Ingrese el código' }]}
                    >
                        <Input 
                            placeholder="Código (F2 para buscar)"
                            style={{ textTransform: 'uppercase' }}
                            onChange={(e) => {
                                const upperValue = e.target.value.toUpperCase();
                                e.target.value = upperValue;

                                verificarTipoAgencia(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'F2') {
                                    e.preventDefault();
                                    handleOpenAgenciasModal();
                                }
                            }}
                            addonAfter={
                                <Button 
                                    type="link" 
                                    icon={<SearchOutlined />} 
                                    onClick={handleOpenAgenciasModal}
                                    loading={buscarAgenciaLoading}
                                    size="small"
                                    title="Buscar agencia (F2)"
                                />
                            }
                        />
                    </Form.Item>
                </Col>
                
                <Col span={12}>
                    <Form.Item
                        name="NomAgencia"
                        label="Nombre / Razón Social"
                        rules={[{ required: true, message: 'Ingrese el nombre' }]}
                    >
                        <Input 
                            placeholder="Nombre del cliente"
                            disabled={!esParticular}
                            addonAfter={
                                esParticular ? (
                                    <Button 
                                        type="link" 
                                        icon={<SearchOutlined />} 
                                        onClick={handleOpenParticularModal}
                                        loading={buscarParticularLoading}
                                        size="small"
                                        title="Buscar particular/empresa (F2)"
                                    />
                                ) : null
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'F2' && esParticular) {
                                    e.preventDefault();
                                    handleOpenParticularModal();
                                }
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="NifAgencia" label="NIF / CIF" rules={[{ required: true, message: 'Ingrese el NIF' }]}>
                    <Input placeholder="NIF/CIF" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="DirAgencia" label="Dirección">
                    <Input placeholder="Dirección" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="PobAgencia" label="Población">
                    <Input placeholder="Población" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="CPAgencia" label="Código Postal">
                    <Input placeholder="Código Postal" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="ProvAgencia" label="Provincia">
                    <Input placeholder="Provincia" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                      name="PaisAgencia"
                      label="Pais"
                    >
                        <Select
                            showSearch
                            placeholder="Seleccione pais"
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {paises.map(pais => (
                                <Option key={pais.Codigo} value={pais.Descripcion} label={pais.Descripcion}>
                                    {renderFlag(pais.CodigoISO)}
                                    {pais.Descripcion}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item 
                        name="FacturarEmpresa" 
                        label="Facturar a Empresa"
                        valuePropName="checked"
                    >
                        <Switch 
                            checkedChildren="Sí" 
                            unCheckedChildren="No"
                            onChange={(checked) => {
                                // Si se activa, forzar esParticular a true para que se pueda buscar
                                if (checked) {
                                    setEsParticular(true);
                                } else {
                                    // Si se desactiva, verificar si el código actual es particular
                                    const codigo = form.getFieldValue('Agencia');
                                    const codigoUpper = codigo?.toUpperCase() || '';
                                    const esParticularTipo = codigoUpper === 'PARTICULARES' || codigoUpper === 'PARTICULARS';
                                    setEsParticular(esParticularTipo);
                                }
                            }}
                        />
                    </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Sección 2: Datos de la Factura */}
            <Card 
              title={
                <Space>
                  <FileTextOutlined />
                  <span>Datos de la Factura</span>
                </Space>
              }
              style={{ marginBottom: 16 }}
            >
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    name="Fecha"
                    label="Fecha"
                    rules={[{ required: true }]}
                  >
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name="Serie" label="Serie">
                    <Select>
                      <Option value="A">A</Option>
                      <Option value="B">B</Option>
                      <Option value="C">C</Option>
                      <Option value="R">R</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name="INCDEC" label="Tipo IVA">
                    <Select>
                      <Option value="I">Incluido</Option>
                      <Option value="D">Desglosado</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item name="NReserva" label="Nº Reserva">
                    <InputNumber style={{ width: '100%' }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item 
                    name="CheckRetencion" 
                    label="Aplicar Retención"
                    valuePropName="checked"
                  >
                    <Switch checkedChildren="Sí" unCheckedChildren="No" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="FacturaRectificada" label="Factura Rectificada">
                    <Input placeholder="Nº Factura Original" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="FechaRectificada" label="Fecha Rectificada">
                    <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Sección 3: Líneas */}
            <Card 
              title={
                <Space>
                  <DollarOutlined />
                  <span>Líneas de la Factura ({lineas.length})</span>
                </Space>
              }
              style={{ marginBottom: 16 }}
              extra={
                <Button 
                  type="primary" 
                  icon={<PlusOutlined />}
                  onClick={handleAddLinea}
                >
                  Añadir Línea
                </Button>
              }
            >
              <Table
                columns={lineasColumns}
                dataSource={lineas}
                rowKey={(_, index) => index}
                pagination={false}
                size="small"
                locale={{ emptyText: 'No hay líneas en esta factura' }}
                summary={() => (
                  <Table.Summary fixed>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={4}>
                        <Text strong>Totales:</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} align="right">
                        <Text strong style={{ color: '#52c41a' }}>
                          € {form.getFieldValue('BaseImponible')?.toFixed(2) || '0.00'}
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} colSpan={2}>
                        <Text strong style={{ color: '#fa8c16' }}>
                          IVA: € {form.getFieldValue('ImporteIVA')?.toFixed(2) || '0.00'}
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3} align="right">
                        <Text strong style={{ fontSize: '16px', color: '#1890ff' }}>
                          Total: € {form.getFieldValue('Total')?.toFixed(2) || '0.00'}
                        </Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </Table.Summary>
                )}
              />
            </Card>

            {/* Sección 4: Totales y Acciones */}
            <Card style={{ marginBottom: 16 }}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Card size="small" style={{ backgroundColor: '#f0f5ff' }}>
                    <Statistic
                      title="Base Imponible"
                      value={form.getFieldValue('BaseImponible') || 0}
                      precision={2}
                      prefix={<EuroOutlined />}
                      valueStyle={{ color: '#1890ff' }}
                    />
                  </Card>
                </Col>
                <Col span={8}>
                  <Card size="small" style={{ backgroundColor: '#fff7e6' }}>
                    <Statistic
                      title="Importe IVA"
                      value={form.getFieldValue('ImporteIVA') || 0}
                      precision={2}
                      prefix={<EuroOutlined />}
                      valueStyle={{ color: '#fa8c16' }}
                    />
                  </Card>
                </Col>
                <Col span={8}>
                  <Card size="small" style={{ backgroundColor: '#f6ffed' }}>
                    <Statistic
                      title="Total Factura"
                      value={form.getFieldValue('Total') || 0}
                      precision={2}
                      prefix={<EuroOutlined />}
                      valueStyle={{ color: '#52c41a' }}
                    />
                  </Card>
                </Col>
              </Row>
            </Card>

            {/* Botones de acción */}
            <Row justify="end" gutter={16}>
              <Col>
                <Button 
                  icon={<RollbackOutlined />}
                  onClick={handleCancel}
                >
                  Limpiar
                </Button>
              </Col>
              <Col>
                <Button 
                  type="primary" 
                  icon={<SaveOutlined />}
                  onClick={handleSaveFactura}
                  loading={saving}
                  size="large"
                >
                  Crear Factura
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>

        {/* Modal para añadir/editar línea */}
        <Modal
          title={editingLineaIndex !== null ? 'Editar Línea' : 'Nueva Línea'}
          open={lineaModalVisible}
          onOk={handleSaveLinea}
          onCancel={() => {
            setLineaModalVisible(false);
            lineaForm.resetFields();
          }}
          width={750}
          okText="Guardar"
          cancelText="Cancelar"
        >
          <Form
            form={lineaForm}
            layout="vertical"
          >
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name="CodigoCargo"
                  label="Código Cargo"
                >
                  <Input
                    placeholder="Código (F2 para buscar)"
                    onKeyDown={(e) => {
                      if (e.key === 'F2') {
                        e.preventDefault();
                        handleOpenCargosModal();
                      }
                    }}
                    addonAfter={
                      <Button 
                        type="link" 
                        icon={<SearchOutlined />} 
                        onClick={handleOpenCargosModal}
                        size="small"
                        title="Buscar cargo (F2)"
                      />
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={18}>
                <Form.Item
                  name="Descripcion"
                  label="Descripción"
                  rules={[{ required: true, message: 'Ingrese la descripción' }]}
                >
                  <Input placeholder="Descripción del cargo/servicio" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={6}>
                <Form.Item name="Precio" label="Precio">
                  <InputNumber style={{ width: '100%' }} min={0} step={0.01} prefix="€" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="DiasCant" label="Cantidad/Días">
                  <InputNumber style={{ width: '100%' }} step={1} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="Seccion" label="Sección">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Seleccionar"
                    allowClear
                  >
                    {secciones.map(sec => (
                      <Option key={sec.value} value={sec.value}>
                        {sec.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="CodigoIVA" label="Código IVA">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Seleccionar"
                    allowClear
                  >
                    {tiposIVA.map(iva => (
                      <Option key={iva.Codigo} value={iva.Codigo}>
                        {iva.Codigo} - {iva.Descripcion} ({iva.Valor}%)
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="FechaEnt" label="Fecha Entrada">
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="FechaSal" label="Fecha Salida">
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="IncDec" label="Tipo IVA Línea">
                  <Select>
                    <Option value="I">Incluido</Option>
                    <Option value="D">Desglosado</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={6}>
                <Form.Item name="Hab" label="Habitación">
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="NReserva" label="Nº Reserva">
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="Observaciones" label="Observaciones">
                  <Input placeholder="Observaciones" />
                </Form.Item>
              </Col>
            </Row>

            <Card size="small" style={{ backgroundColor: '#f6ffed' }}>
              <div style={{ fontSize: '12px', color: '#666' }}>
                <strong>💡 Ayuda:</strong>
                <ul style={{ marginTop: 4, marginBottom: 4, paddingLeft: 20 }}>
                  <li>Presione <strong>F2</strong> en "Código Cargo" para buscar un cargo en la lista</li>
                  <li>La cantidad/días se multiplica por el precio y los días entre fechas</li>
                  <li>El IVA se calcula automáticamente según el tipo seleccionado</li>
                </ul>
              </div>
            </Card>
          </Form>
        </Modal>

        {/* Modal para listar todos los cargos */}
        <Modal
          title={
            <Space>
              <ShoppingOutlined />
              <span>Seleccionar Cargo</span>
            </Space>
          }
          open={cargosModalVisible}
          onCancel={() => setCargosModalVisible(false)}
          footer={null}
          width={700}
          bodyStyle={{ maxHeight: '500px', overflowY: 'auto' }}
        >
          <div style={{ marginBottom: 16 }}>
            <Search
              placeholder="Buscar por código o descripción..."
              allowClear
              enterButton="Buscar"
              size="large"
              value={cargosSearchText}
              onChange={(e) => handleSearchCargos(e.target.value)}
              onSearch={handleSearchCargos}
            />
            <div style={{ marginTop: 8, color: '#999', fontSize: '12px' }}>
              {cargosFiltered.length} cargos encontrados
            </div>
          </div>

          <List
            loading={cargosLoading}
            dataSource={cargosFiltered}
            renderItem={(cargo) => (
              <List.Item
                key={cargo.Codigo}
                actions={[
                  <Button 
                    type="primary" 
                    size="small"
                    onClick={() => handleSelectCargo(cargo)}
                  >
                    Seleccionar
                  </Button>
                ]}
              >
                <List.Item.Meta
                  avatar={<Avatar icon={<TagOutlined />} style={{ backgroundColor: '#1890ff' }} />}
                  title={
                    <Space>
                      <Tag color="blue">{cargo.codigo}</Tag>
                      <Text strong>{cargo.descripcion}</Text>
                    </Space>
                  }
                  description={
                    <Space size={16}>
                      {cargo.precio && (
                        <span>
                          <EuroOutlined /> {cargo.precio.toFixed(2)}
                        </span>
                      )}
                      {cargo.seccion && (
                        <span>
                          <TagOutlined /> Sección: <Tag color="green">{cargo.seccion}</Tag>
                        </span>
                      )}
                      {cargo.codigoiva && (
                        <span>
                          IVA: <Tag color="orange">{cargo.codigoiva}</Tag>
                        </span>
                      )}
                    </Space>
                  }
                />
              </List.Item>
            )}
            locale={{ emptyText: 'No se encontraron cargos' }}
          />
          
          <div style={{ marginTop: 16, textAlign: 'right' }}>
            <Button onClick={() => setCargosModalVisible(false)}>
              Cerrar
            </Button>
          </div>
        </Modal>

        {/* Modal para listar todas las agencias/particulares */}
        <Modal
            title={
                <Space>
                    <TeamOutlined />
                    <span>Seleccionar Cliente</span>
                </Space>
            }
            open={agenciasModalVisible}
            onCancel={() => setAgenciasModalVisible(false)}
            footer={null}
            width={700}
            bodyStyle={{ maxHeight: '500px', overflowY: 'auto' }}
        >
            <div style={{ marginBottom: 16 }}>
                <Search
                    placeholder="Buscar por código, nombre o NIF..."
                    allowClear
                    enterButton="Buscar"
                    size="large"
                    value={agenciasSearchText}
                    onChange={(e) => handleSearchAgencias(e.target.value)}
                    onSearch={handleSearchAgencias}
                />
                <div style={{ marginTop: 8, color: '#999', fontSize: '12px' }}>
                    {agenciasFiltered.length} clientes encontrados
                </div>
            </div>

            <List
                loading={agenciasLoading}
                dataSource={agenciasFiltered}
                renderItem={(cliente) => (
                    <List.Item
                        key={cliente.Codigo}
                        actions={[
                            <Button 
                                type="primary" 
                                size="small"
                                onClick={() => handleSelectAgencia(cliente)}
                            >
                                Seleccionar
                            </Button>
                        ]}
                    >
                        <List.Item.Meta
                            avatar={
                                <Avatar 
                                    icon={cliente.tipo === 'particular' ? <UserOutlined /> : <HomeOutlined />} 
                                    style={{ 
                                        backgroundColor: cliente.tipo === 'particular' ? '#52c41a' : '#1890ff' 
                                    }} 
                                />
                            }
                            title={
                                <Space>
                                    <Tag color={cliente.tipo === 'particular' ? 'green' : 'blue'}>
                                        {cliente.tipo === 'particular' ? 'PART' : 'AGEN'}
                                    </Tag>
                                    <Tag color="blue">{cliente.Codigo}</Tag>
                                    <Text strong>{cliente.Nombre}</Text>
                                </Space>
                            }
                            description={
                                <Space size={16} wrap>
                                    {cliente.NIF && (
                                        <span>
                                            <IdcardOutlined /> {cliente.NIF}
                                        </span>
                                    )}
                                    {cliente.Direccion && (
                                        <span>
                                            <EnvironmentOutlined /> {cliente.Direccion}
                                        </span>
                                    )}
                                    {cliente.Poblacion && (
                                        <span>
                                            <HomeOutlined /> {cliente.Poblacion}
                                        </span>
                                    )}
                                    {cliente.Credito !== undefined && (
                                        <Tag color={cliente.Credito ? 'green' : 'orange'}>
                                            {cliente.Credito ? 'Crédito' : 'Contado'}
                                        </Tag>
                                    )}
                                </Space>
                            }
                        />
                    </List.Item>
                )}
                locale={{ emptyText: 'No se encontraron clientes' }}
            />
            
            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Button onClick={() => setAgenciasModalVisible(false)}>
                    Cerrar
                </Button>
            </div>
        </Modal>

        {/* Modal para buscar particulares o empresas */}
        <Modal
            title={
                <Space>
                    {form.getFieldValue('FacturarEmpresa') ? <BankOutlined /> : <UserOutlined />}
                    <span>{form.getFieldValue('FacturarEmpresa') ? 'Seleccionar Empresa' : 'Seleccionar Particular'}</span>
                </Space>
            }
            open={buscarParticularModalVisible}
            onCancel={() => setBuscarParticularModalVisible(false)}
            footer={null}
            width={700}
            bodyStyle={{ maxHeight: '500px', overflowY: 'auto' }}
        >
            <div style={{ marginBottom: 16 }}>
                <Search
                    placeholder="Buscar por código, nombre o NIF..."
                    allowClear
                    enterButton="Buscar"
                    size="large"
                    value={buscarParticularSearchText}
                    onChange={(e) => handleSearchParticular(e.target.value)}
                    onSearch={handleSearchParticular}
                />
                <div style={{ marginTop: 8, color: '#999', fontSize: '12px' }}>
                    {buscarParticularFiltered.length} {form.getFieldValue('FacturarEmpresa') ? 'empresas' : 'particulares'} encontrados
                </div>
            </div>

            <List
                loading={buscarParticularLoading}
                dataSource={buscarParticularFiltered}
                renderItem={(item) => (
                    <List.Item
                        key={item.Codigo}
                        actions={[
                            <Button 
                                type="primary" 
                                size="small"
                                onClick={() => handleSelectParticular(item)}
                            >
                                Seleccionar
                            </Button>
                        ]}
                    >
                        <List.Item.Meta
                            avatar={
                                <Avatar 
                                    icon={form.getFieldValue('FacturarEmpresa') ? <BankOutlined /> : <UserOutlined />} 
                                    style={{ 
                                        backgroundColor: form.getFieldValue('FacturarEmpresa') ? '#fa8c16' : '#52c41a' 
                                    }} 
                                />
                            }
                            title={
                                <Space>
                                    <Tag color={form.getFieldValue('FacturarEmpresa') ? 'orange' : 'green'}>
                                        {form.getFieldValue('FacturarEmpresa') ? 'EMP' : 'PART'}
                                    </Tag>
                                    <Tag color="blue">{item.Codigo}</Tag>
                                    <Text strong>{item.Nombre}</Text>
                                </Space>
                            }
                            description={
                                <Space size={16} wrap>
                                    {item.Nif && (
                                        <span>
                                            <IdcardOutlined /> {item.Nif}
                                        </span>
                                    )}
                                    {item.Direccion && (
                                        <span>
                                            <EnvironmentOutlined /> {item.Direccion}
                                        </span>
                                    )}
                                    {item.Poblacion && (
                                        <span>
                                            <HomeOutlined /> {item.Poblacion}
                                        </span>
                                    )}
                                </Space>
                            }
                        />
                    </List.Item>
                )}
                locale={{ emptyText: `No se encontraron ${form.getFieldValue('FacturarEmpresa') ? 'empresas' : 'particulares'}` }}
            />
            
            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Button onClick={() => setBuscarParticularModalVisible(false)}>
                    Cerrar
                </Button>
            </div>
        </Modal>

      </PageContainer>
    </>
  );
};

export default VentaDirectaForm;